var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "moreReport" },
    [
      _vm.data.dataType == -2
        ? [
            _c(
              "div",
              { staticClass: "btnGroup" },
              _vm._l(_vm.data.jsonData.recommendQ, function (item, index) {
                return _c(
                  "el-button",
                  {
                    key: index,
                    staticClass: "marginLeft0",
                    attrs: { plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.sendQuest(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
            _vm._l(_vm.data.jsonData.idTitle, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "btnGroup" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setQusetType(item)
                        },
                      },
                    },
                    [
                      _c("svg-icon", {
                        staticStyle: { "font-size": "24px" },
                        attrs: { name: "pdf" },
                      }),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$i18.language("加载")) +
                            "《" +
                            _vm._s(item.title) +
                            "》" +
                            _vm._s(_vm.$i18.language("提问"))
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "lineHeight24",
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goMarketResearch(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$i18.language("前往")) +
                          "《" +
                          _vm._s(item.title) +
                          "》"
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
          ]
        : _vm.data.dataType == -3
        ? [
            _vm.data.tabledata.result.companyID
              ? _c(
                  "el-button",
                  {
                    staticClass: "marginLeft0",
                    attrs: { plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.goContactCompany("companyID")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$i18.language("查看公司详情")))]
                )
              : _vm._e(),
            _vm.data.tabledata.result.searchKey
              ? _c(
                  "el-button",
                  {
                    staticClass: "marginLeft0",
                    attrs: { plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.goContactCompany("searchKey")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$i18.language("查看公司联系人")))]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }